import React, { useCallback, useState } from 'react';
import Modal from '~/components/Modal';
import FormHeader from '~/components/form/form-header';
import FormFooter from '~/components/form/form-footer';
import { useForm } from '~/hooks';
import { TextArea } from '~/components/form';
import { FileDrop } from '~/components';

/** @type {SubmitRevisionValues} */
const defaultState = {
    id: 0,
    titleOpinionId: 0,
    revisions: '',
    files: []
};

const loadData = async (values, props) => {  
       
    return {
        ...values,
        ...props 
    };
};


const SubmitRevision = (props) => {

    const onLoad = useCallback((values, props) => {
        return loadData(values, props);
    }, [props.isModalOpen]);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        props,
        onLoad,
        debug: true
    });     

    const [errorMessage, setErrorMessage] = useState(false);

    return (
        <Modal
            isModalOpen={props.isModalOpen}
            className='bg-white p-4 rounded-md'
        >
            <div className='row col-md-12'>                 
                <FormHeader headerTxt={`${props.headerTxt}`} className='text-blue-60 text-4xl justify-center'/>

                {errorMessage ? 
                    <div className="bg-red-600 text-white text-sm rounded-md px-2 py-1 h-8 -mt-4"> 
                        <p>Empty revisions are not supported. Please submit a valid revision.</p> 
                    </div>
                    :
                    <div className="text-sm rounded-md px-2 py-1 h-8 -mt-4"> </div>
                }  
                <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">
                    <TextArea
                        rows={4}
                        type="textarea"
                        required
                        label="Enter any revisions needed on this order"
                        name="revisions"
                        path="revisions"
                        groupClassName="col-span-8 mt-4"
                        inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                        value={state.values.revisions}
                        error={state.errors.revisions}
                        {...fieldActions}
                        onChange={(revisions) => {
                            setErrorMessage(false);
                            fieldActions.onChange(revisions, 'revisions');
                        }}                    
                    />
                    <FileDrop
                        files={state.values.files}
                        className='w-full h-16'
                        groupClassName='col-span-8 mt-4'
                        onChange={files => {
                            setErrorMessage(false);
                            fieldActions.onChange(files, 'files');
                        }}
                        multiple
                        heading='Attach any necessary files'
                        onRemove={(_, index) => {
                            const files = [...state.values.files];
                            files.splice(index, 1);
                            fieldActions.onChange(files, 'files');
                        }}
                    />
                        
                     
                    <div className="col-span-8 flex justify-end items-center">                                        
                        <FormFooter
                            cancelBtnTxt={'Cancel'}
                            submitBtnTxt={ 'Submit'}
                            onSubmit={() => {
                                if(state.values.revisions.trim() != "") {                                    
                                    props.onSubmit(state.values);
                                } else {
                                    setErrorMessage(true);
                                    
                                    
                                }
                            }}
                            onCancel={props.onCancel}
                        />                                    
                    </div>
                    
                </div>
            </div>
        </Modal>
    );
};

export default SubmitRevision;

